module.exports = __webpack_public_path__ + "static/media/communities.c26d4bac.svg";